import { Config } from '~domain/entities/Config';
import { IStoresCoordinates } from '~interfaces/IStoresInterfaces';

export interface IGoogleMapsResults {
    formatted_address: string;
    geometry: {
        location: {
            lat: number;
            lng: number;
        };
    };
}

export interface IGoogleMapsResponse {
    address: string;
    status: string;
    results: IGoogleMapsResults[];
}

export class GoogleMapsApi {
    configService: Config;
    /* eslint-disable  @typescript-eslint/no-explicit-any */
    geocoder: any;

    constructor(config: Config) {
        this.configService = config;
        this.loadApi();
    }

    public async loadApi() {
        await this.waitForGoogleMaps();
        if (!this.geocoder && !!window.google?.maps) {
            this.geocoder = new google.maps.Geocoder();
        }
    }

    public async waitForGoogleMaps() {
        return new Promise<void>((resolve, reject) => {
            // Allow interval to run the check 10 times.
            const timeoutDuration = 5100;

            const checkGoogleMaps = setInterval(() => {
                if (window.google && window.google.maps) {
                    clearInterval(checkGoogleMaps);
                    resolve();
                }
            }, 500);

            setTimeout(() => {
                if (!window.google || !window.google.maps) {
                    clearInterval(checkGoogleMaps);
                    reject('GoogleMaps: time out');
                }
            }, timeoutDuration);
        }).catch((e) => {
            e && console.warn(e);

            return e;
        });
    }

    getAdressFromCoordinates = async (latlng: IStoresCoordinates): Promise<IGoogleMapsResponse> => {
        await this.loadApi();
        const response = await this.geocoder.geocode({ location: latlng });

        return response;
    };

    getCoordinatesFromZip = async (zipcode: string): Promise<IGoogleMapsResponse> => {
        await this.loadApi();
        const response = await this.geocoder.geocode({ address: zipcode });

        return response;
    };
}
